type Props = { className?: string }

/**
 * Legacy's caret (navbar-dropdown/style.tsx `CaretDown`/`CaretUp`) swaps
 * between two icon-font glyphs (`ss-navigatedown`/`ss-navigateup`) on hover.
 * This port can't do the same swap: `packages/ui/src/css.ts`'s
 * `ssStandardCss` only ports an 11-glyph subset of legacy's 185
 * (`ss-navigatedown`, `ss-navigateright`, `ss-navigateleft`, `ss-check`,
 * `ss-heart`, `ss-link`, `ss-flag`, `ss-write`, `ss-barchart`, `ss-mail`,
 * `ss-video`) and `ss-navigateup` is not one of them — using it would render
 * an invisible glyph (verified by reading css.ts directly, not assumed).
 * A single inline SVG, rotated 180deg on hover via the trigger's own
 * `group-hover:rotate-180`, reproduces the down/up swap without depending on
 * the icon font at all.
 */
const ChevronIcon = ({ className }: Props) => (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true" className={className}>
        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default ChevronIcon
